<template>
    <div id="stream-cont" v-on:click="clicked()" v-bind:style="{left: s_left, width: s_width, height: s_height, opacity: s_opacity, zIndex: s_z_index}">
        <div v-if="in_focus" class="stream-slide" >
            <!-- <iframe v-bind:src="channel_data.url" style="background-color: black ; height: 400px; border: none; border-radius: 20px; overflow: hidden; box-shadow: 0px 10px 40px Black;"></iframe> -->
            <iframe
              v-bind:src="channel_data.url"
              height="400"
              width="600"
              class="stream-frame">
          </iframe>
             <div class="stream-info">
                 <tr>
                    <td>
                        <img :src="channel_data.prof_pic"/>
                    </td>
                    <td>
                        <h1>{{channel_data.name}}</h1>
                    </td>
                 </tr>
                <a>{{channel_data.description}}</a>
             </div>
        </div>
        <div v-else class="stream-slide" style="border-radius: 20px; overflow: hidden;">
            <img :src="channel_data.banner" style="width:100%; height:100%; object-fit: cover; overflow: hidden;"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'stream-slider',
  props: ['channel_data', 'focus_index'],
  data () {
    return {
      s_left: '50%',
      s_width: '640px',
      s_height: '360px',
      s_opacity: '1',
      s_z_index: '150',
      in_focus: false
    }
  },
  watch: {
    focus_index: function (val) {
      this.changeFocus(val)
    }
  },
  methods: {
    changeFocus (val) {
      this.s_left = (val * 20 + 50) + '%'
      this.s_width = (640 - (Math.abs(val) * (300 / 5))) + 'px'
      this.s_height = (360 - (Math.abs(val) * (200 / 5))) + 'px'

      if (val === 0) {
        this.s_opacity = '1'
        this.s_z_index = '150'
        setTimeout(() => {
          this.in_focus = true
        }, 500)
      } else if (val === 1 || val === -1) {
        this.s_opacity = '0.5'
        this.s_z_index = '149'
        this.in_focus = false
      } else {
        this.s_opacity = '0'
        this.s_z_index = '148'
        this.in_focus = false
      }
      console.log('CHANGED: ' + this.s_left)
    },
    clicked () {
      console.log('clicked!!!' + this.channel_data.focus_index)
      this.$emit('slideClicked', this.channel_data.focus_index)
    }
  },
  created () {
    this.changeFocus(this.channel_data.focus_index)
  }
}
</script>

<style scoped>
    .stream-slide{
        width: 100%;
        height: 100%;
        border: none;
        box-sizing: border-box;
        cursor: pointer;
    }
    #stream-cont{
        width: 300px;
        height: 200px;
        position: absolute;
        left: 50%;
        top: 35%;
        transform: translate(-50%, -50%);
        opacity: 1;
        z-index: 150;
        transition-property: left , width , height, z-index, opacity;
        transition-duration: 0.5s;
        transition-timing-function: ease;
    }
    .stream-info td{
        padding: 5px;
        vertical-align: middle;
        text-align: left;
    }
    .stream-info img{
        height: 70px;
        width: 70px;
        border-radius: 50%;
    }
    .stream-info h1{
        margin: 0px;
        font-size: 40px;
    }
    .stream-info a{
        margin: 0px;
        color: lightslategray;
    }
    .stream-frame{
      border-radius: 10px;
      outline: none;
      border: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/stream-slide.vue